module.exports = __webpack_public_path__ + "static/img/01.af2eb8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/06/01.jpg
// module id = mvo6
// module chunks = 0